import { Outlet } from "react-router-dom";

import { useAuth } from "auth/AuthContext";
import Sidebar from "components/Navigation/Sidebar";
import Header from "components/Navigation/Header";
import PageTitle from "components/Navigation/PageTitle";

import HomeIcon from "assets/icons/home.svg?react";
import CoursesIcon from "assets/icons/courses.svg?react";
import BookMeetingIcon from "assets/icons/bookMeeting.svg?react";
import EmailIcon from "assets/icons/email.svg?react";
import AcademicOverviewIcon from "assets/icons/academicOverview.svg?react";
import quickLinksIcon from "assets/icons/quickLinks.svg?react";
import supportIcon from "assets/icons/support.svg?react";

import styles from "./Layout.module.css";
import ErrorBoundary from "../ErrorBoundary";

const Layout = () => {
    const { isAdmin } = useAuth();

    // TODO: Move navItems to a separate file and filter based on user role
    const navItems = [
        { label: "Home", link: "/dashboard", icon: HomeIcon },
        { label: "My Students Courses", link: "/courses", icon: CoursesIcon },
        {
            label: "Academic Overview",
            link: "https://gouspa.maestrosis.com",
            icon: AcademicOverviewIcon,
            isExternal: true,
        },
        {
            label: "Quick Links",
            icon: quickLinksIcon,
            hasSubItems: true,
            subItemsLabel: "Quick Links",
            subItems: [
                {
                    label: "Manage My Tuition",
                    link: "https://billing.stripe.com/p/login/eVqeVe9Vu24N3dX7DR5ZC00",
                    isExternal: true,
                },
                {
                    label: "College Admissions",
                    link: "https://app.scoir.com/signin",
                    isExternal: true,
                },
                {
                    label: "School Store",
                    link: "https://shop.gouspa.org",
                    isExternal: true,
                },
                {
                    label: "Transcripts",
                    link: "https://registration.parchment.com/member/3fc0f50e-0d1e-11ed-ab0b-9fc21804c964",
                    isExternal: true,
                },
            ],
        },
        { label: "Support", link: "/support", icon: supportIcon },
    ];

    const adminNavItems = [
        { label: "Dashboard", link: "/dashboard", icon: HomeIcon },
    ];

    return (
        <ErrorBoundary>
            <div className={styles.Layout}>
                <Sidebar navItems={isAdmin ? adminNavItems : navItems}/>
                <div className={styles.Main} data-testid="main-content">
                    <Header/>
                    <PageTitle/>
                    <div className={styles.Content} data-testid="page-content">
                        <Outlet/>
                    </div>
                </div>
            </div>
        </ErrorBoundary>
    );
};

export default Layout;
